import React from 'react';
import PropTypes from 'prop-types';

const WhenLocalhost = ({ children }) => {
  if (window.location.hostname !== 'localhost') return null;
  return <>{children}</>;
};

WhenLocalhost.propTypes = {
  children: PropTypes.any,
};

export default WhenLocalhost;
